
    import Vue from "vue";
    import Component from 'vue-class-component';
    import { Prop } from "vue-property-decorator";
    import {
        GetMedicalCertificateResponse,
        MedicalCertificatesClient,
    } from "@/api-client";
    import Files from "@/components/Files.vue";
    import { translateTrueFalse } from "@/features/shared/TrueFalseTranslator";
    import QrCode from "@/components/QrCode.vue";

@Component({
    components: {
        Files,
        QrCode
    },
    methods: {
        translateTrueFalse: translateTrueFalse
    }
})
export default class MedicalCertificateDetailsContent extends Vue {
    @Prop()
    id!: string;
    @Prop()
    seafarerId!: string;
    @Prop()
    details!: GetMedicalCertificateResponse;
    dataLoaded = false;
    medicalCertificate = this.details;
    @Prop()
    isOfficial?: boolean;

    async created() {
        if (!this.medicalCertificate) {
            this.medicalCertificate = await new MedicalCertificatesClient().get(this.id)
                .then(successResponse => this.medicalCertificate = successResponse);
        }
        this.dataLoaded = true;
    }

    get hasRestrictions(): boolean {
        return this.medicalCertificate.restrictionNames.length > 0;
    }

    async getDownloadUrl(fileId: string): Promise<string> {
        return (await new MedicalCertificatesClient().downloadFile(this.$route.params.id, fileId)).url;
    }
}
